import { render, staticRenderFns } from "./CarDetails.vue?vue&type=template&id=def0e1ee&scoped=true&"
import script from "./CarDetails.vue?vue&type=script&lang=js&"
export * from "./CarDetails.vue?vue&type=script&lang=js&"
import style0 from "./CarDetails.vue?vue&type=style&index=0&id=def0e1ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def0e1ee",
  null
  
)

export default component.exports